import localize from '../../common/localize';
import NoDataLabel from './NoDataLabel';

export default function ValueOrNoDataLabel({
  data,
  hideBackground,
  centerValue,
}) {
  return data && data.length > 0 ? (
    centerValue ? (
      <p className="textAlignedCenter">{data}</p>
    ) : (
      data
    )
  ) : hideBackground ? (
    <p className={centerValue ? "textAlignedCenter" : ""}>{localize.no_data}</p>
  ) : (
    <NoDataLabel />
  );
}
